import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { acceptFlexMatchRequest } from 'RestAPIs/flex-match';

export type AcceptFlexMatchRequestPayload = {
  taskId: string;
  body: {
    formdata: {
      actions: 'accept';
    };
  };
};

const useAcceptFlexMatchRequest = ({ isWebSocketUpdate = false }) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: AcceptFlexMatchRequestPayload) => acceptFlexMatchRequest(payload),
    {
      onSuccess: () => {
        !isWebSocketUpdate && queryClient.invalidateQueries('flexMatchTasks');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAcceptFlexMatchRequest;
